import { ComponentPropsWithoutRef } from 'react';

export const StressLevelChartMobile = (
  props: ComponentPropsWithoutRef<'svg'> & { level: number },
) => (
  <svg
    width="40"
    height="32"
    viewBox="0 0 40 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={props.style}
  >
    <rect
      x="0.5"
      y="26.5"
      width="5"
      height="5"
      rx="1.5"
      fill={props.level >= 1 ? '#9788C0' : '#E1D4EB'}
      stroke="#9788C0"
    />
    <rect
      x="8.5"
      y="20.5"
      width="6"
      height="11"
      rx="1.5"
      fill={props.level >= 2 ? '#9788C0' : '#E1D4EB'}
      stroke="#9788C0"
    />
    <rect
      x="17.5"
      y="14.5"
      width="5"
      height="17"
      rx="1.5"
      fill={props.level >= 3 ? '#9788C0' : '#E1D4EB'}
      stroke="#9788C0"
    />
    <rect
      x="25.5"
      y="8.5"
      width="6"
      height="23"
      rx="1.5"
      fill={props.level >= 4 ? '#9788C0' : '#E1D4EB'}
      stroke="#9788C0"
    />
    <rect
      x="34.5"
      y="0.5"
      width="5"
      height="31"
      rx="1.5"
      fill={props.level >= 5 ? '#9788C0' : '#E1D4EB'}
      stroke="#9788C0"
    />
  </svg>
);
